import { render, staticRenderFns } from "./BookingRules.vue?vue&type=template&id=1e35d90d&scoped=true&lang=html&"
import script from "./BookingRules.vue?vue&type=script&lang=js&"
export * from "./BookingRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e35d90d",
  null
  
)

export default component.exports